import request from '@/api/request'

/** 公开分类（与旧版文章 cat_id 对应），无需 PORTAL；管理端页内拉取下拉用。 */
export interface CategoryRow {
  id: number
  name: string | null
  ename: string | null
  addtime: number | null
  pid: number | null
  sort: number | null
  cont: string | null
  keywords: string | null
  description: string | null
  thumbnail: string | null
}

export function fetchPublicCategories() {
  return request.get<CategoryRow[]>('/api/portal/public/categories')
}
